import React from 'react';

const ExternalLink = ({href, targetBlank, className, children}: any) => {
  const extraProps = {};

  if (targetBlank) {
    extraProps['target'] = '_blank';
    extraProps['rel'] = 'noopener';
  }

  return (
    <a href={href} className={className} {...extraProps}>
      {children}
    </a>
  );
};

export default ExternalLink;
